export const modes = {
  view: "view",
  edit: "edit",
  create: "create",
};
